import type { FragmentItemsFieldsFragment } from 'cart/services/fragments.generated'
import type { ItemPromotion } from 'codegen/src/gateway/types'
import { getCrossedOutPrices } from 'prices/utils/getCrossedOutPrices/getCrossedOutPrices'
import type { Prices, ProductPrices } from 'product/types/Prices'
import { Channel } from 'types/masterData'
import { handlePreviousPrices } from './handlePreviousPrices'

type PriceFragment = FragmentItemsFieldsFragment['price']

export const parsePriceData = (
	price: PriceFragment,
	promoCode: ItemPromotion | undefined,
	hasPriceHistory: boolean,
	hidePriceHistory = false
): Prices => {
	const currentPrice = price.current.currentPrice ?? 0
	const discountRate = price.discountRate ?? 0
	const promoDiscount = promoCode?.code ? promoCode?.price?.amount : null
	const shopOriginalPrice = price.previous?.original?.shop?.amount
	const outletOriginalPrice = price.previous?.original?.outlet?.amount
	const initialPrice = price.initial.initialPrice

	const previousPrices = {
		originalShop: handlePreviousPrices(
			shopOriginalPrice,
			undefined,
			Channel.Shop,
			promoDiscount,
			initialPrice
		),
		originalOutlet: handlePreviousPrices(
			undefined,
			outletOriginalPrice,
			Channel.Outlet,
			promoDiscount,
			initialPrice
		),
	}

	const lowestPrices = {
		sale: price.previous?.lowest?.sale?.amount ?? undefined,
		promo: price.previous?.lowest?.promo?.amount ?? undefined,
	}

	const parsedPrices: ProductPrices = {
		price: promoDiscount ?? currentPrice,
		previousPrices,
		lowestPrices,
		discountRate,
	}

	const { crossedOutPrices, allCrossedOutWithoutLowest } = getCrossedOutPrices({
		prices: parsedPrices,
		hidePriceHistory,
		hasPriceHistory,
	})

	return {
		price: parsedPrices.price,
		discountRate: parsedPrices.discountRate,
		crossedOutPrices,
		allCrossedOutWithoutLowest,
	}
}
